import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=02bd3a90&scoped=true&"
import script from "./Packages.vue?vue&type=script&lang=js&"
export * from "./Packages.vue?vue&type=script&lang=js&"
import style0 from "./Packages.vue?vue&type=style&index=0&id=02bd3a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bd3a90",
  null
  
)

export default component.exports